export const tr = {
    'expander-error': 'Tahmin geçici olarak kullanılamıyor',
    'expander-header': "Banner'ları ekleyin",
    'expander-no-data': 'Kullanıcı profilinin bazı özelliklerini kapatın veya genişletin',
    increase: 'Kapsamı arttır'
};
